import {
  parseQuotationPriceUOMDTO,
  QuotationPriceUOMDTO
} from 'components/ordering/quotation/api/dtos/quotation-price-uom-dto.js'
import {
  parseQuotationProductDTO,
  QuotationProductDTO
} from 'components/ordering/quotation/api/dtos/quotation-product-dto.js'
import { createValidate } from 'typia'
import { validateGuard } from 'components/shared/parsing/parsing.js'

export type IQuotationLineDTO = {
  id: number
  line_number: number | null
  group_code: string | null
  group_accepted: boolean | null
  quantity: number
  price: string
  price_formatted: string
  price_uom: unknown
  product: unknown
}

export class QuotationLineDTO {
  id: number
  lineNumber: number | null
  groupCode: string | null
  groupAccepted: boolean | null
  quantity: number
  price: string
  priceFormatted: string
  priceUom: QuotationPriceUOMDTO
  product: QuotationProductDTO

  constructor(data: IQuotationLineDTO) {
    this.id = data.id
    this.lineNumber = data.line_number
    this.groupCode = data.group_code
    this.groupAccepted = data.group_accepted
    this.quantity = data.quantity
    this.price = data.price
    this.priceFormatted = data.price_formatted
    this.priceUom = parseQuotationPriceUOMDTO(data.price_uom)
    this.product = parseQuotationProductDTO(data.product)
  }
}

const validate = createValidate<IQuotationLineDTO>()

export const parseQuotationLineDTO = (data: unknown) => {
  validateGuard(validate, data, 'quotation line')
  return new QuotationLineDTO(data)
}
